class ImportPricingNavCtrl {
  static bindings = {
    activeTab: '<',
    onChange: '&'
  };

  active;
  onChange;

  constructor(private UploadModel) {
    'ngInject';
  }

  $onChanges(changes) {
    if (changes.activeTab) {
      this.active = changes.activeTab.currentValue;
    }
  }

  isComplete(name) {
    // TODO: Eliminate this dependency on the model by passing in the list of tabs with a completed value for each
    return this.UploadModel.isTabComplete(name);
  }

  changeActiveTab(activeTab) {
    this.onChange({
      $event: {
        activeTab
      }
    });
  }
}

export const ImportPricingNavComponent = {
  controller: ImportPricingNavCtrl,
  template: require('./importPricingNav.component.html'),
  bindings: ImportPricingNavCtrl.bindings
};
